export default __webpack_public_path__ + "static/media/download.b71aa7df.svg";